import {HttpHeaders} from '@angular/common/http';
import {UploadFile} from '../../store/types';

export class FileHttpHeaders extends HttpHeaders {
    public files: UploadFile[];
}
